"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getCookie = getCookie;
exports.ActivationModal = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Modal = _interopRequireDefault(require("../../../../components/Modal"));

var _Button = _interopRequireDefault(require("../../../../components/Button"));

var _apps = _interopRequireDefault(require("../../../../config/apps"));

var _activateProduct = require("../../../../api/activate-product");

var _productsStatus = require("../AppSwitcher/productsStatus");

var _ActivationContent = require("./ActivationContent");

var _Message = _interopRequireDefault(require("../../../../components/Message/Message"));

var _urlParse = _interopRequireDefault(require("url-parse"));

var _requestAccess = require("../../../../api/request-access");

var ActivationModal = function ActivationModal(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isLoading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      messageType = _useState4[0],
      setMessageType = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      isAccessRequested = _useState6[0],
      setIsAccessRequested = _useState6[1];

  var originProduct = props.originProduct,
      targetProduct = props.targetProduct,
      productStatus = props.productStatus,
      isOpen = props.isOpen,
      onClose = props.onClose,
      swicusOrgId = props.swicusOrgId,
      environment = props.environment;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    "data-qa": "activation-modal-".concat(targetProduct),
    className: "activation-modal",
    open: isOpen,
    onClose: closeModal,
    closeIcon: true,
    size: "large"
  }, /*#__PURE__*/_react["default"].createElement(_Modal["default"].Content, null, /*#__PURE__*/_react["default"].createElement(_ActivationContent.ActivationContent, {
    product: targetProduct,
    productStatus: productStatus
  }), messageType === 'error' && /*#__PURE__*/_react["default"].createElement(_Message["default"], {
    error: true,
    "data-qa": "activation-error-message"
  }, /*#__PURE__*/_react["default"].createElement(_Message["default"].Header, null, "Something went wrong"), /*#__PURE__*/_react["default"].createElement("p", null, "Please try again and if the problem persists, ", getContactLink(), ".")), messageType === 'success' && /*#__PURE__*/_react["default"].createElement(_Message["default"], {
    positive: true,
    header: "Your access request was sent to your Organization Owner",
    content: "You will receive an email once your request has been accepted.",
    "data-qa": "activation-success-message"
  })), /*#__PURE__*/_react["default"].createElement(_Modal["default"].Actions, null, /*#__PURE__*/_react["default"].createElement(ActionButtons, {
    isAccessRequested: isAccessRequested,
    targetProduct: targetProduct,
    productStatus: productStatus,
    onClose: closeModal,
    onActionButtonClick: processProductActivation,
    isLoading: isLoading
  })));

  function processProductActivation() {
    return _processProductActivation.apply(this, arguments);
  }

  function _processProductActivation() {
    _processProductActivation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setLoading(true);
              _context.t0 = productStatus;
              _context.next = _context.t0 === _productsStatus.PRODUCT_STATUS.CAN_ACTIVATE ? 5 : _context.t0 === _productsStatus.PRODUCT_STATUS.ACCESS_NEEDED ? 10 : 15;
              break;

            case 5:
              _context.next = 7;
              return (0, _activateProduct.activateProduct)(environment, swicusOrgId, targetProduct, originProduct);

            case 7:
              goToProduct(swicusOrgId, environment, targetProduct);
              closeModal();
              return _context.abrupt("break", 16);

            case 10:
              _context.next = 12;
              return (0, _requestAccess.requestAccess)(environment, swicusOrgId, targetProduct, originProduct);

            case 12:
              setIsAccessRequested(true);
              setMessageType('success');
              return _context.abrupt("break", 16);

            case 15:
              setMessageType('error');

            case 16:
              _context.next = 22;
              break;

            case 18:
              _context.prev = 18;
              _context.t1 = _context["catch"](0);
              setMessageType('error');
              /* eslint-disable-next-line no-console */

              console.error("Activation product \"".concat(targetProduct, "\" failed with error: ").concat(_context.t1));

            case 22:
              setLoading(false);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 18]]);
    }));
    return _processProductActivation.apply(this, arguments);
  }

  function getContactLink() {
    var product = _apps["default"].find(function (app) {
      return app.id === targetProduct;
    });

    if (product) {
      return /*#__PURE__*/_react["default"].createElement("a", {
        href: product.url.contact
      }, "contact support");
    } else {
      return 'contact support';
    }
  }

  function closeModal() {
    onClose();
    setIsAccessRequested(false);
    setMessageType('');
  }
};

exports.ActivationModal = ActivationModal;

var ActionButtons = function ActionButtons(_ref) {
  var targetProduct = _ref.targetProduct,
      onClose = _ref.onClose,
      productStatus = _ref.productStatus,
      onActionButtonClick = _ref.onActionButtonClick,
      isLoading = _ref.isLoading,
      isAccessRequested = _ref.isAccessRequested;

  var product = _apps["default"].find(function (app) {
    return app.id === targetProduct;
  });

  var productHomepageLink = product ? product.url.homepage : undefined;

  if (productHomepageLink && (productStatus === _productsStatus.PRODUCT_STATUS.CAN_ACTIVATE || productStatus === _productsStatus.PRODUCT_STATUS.ACCESS_NEEDED)) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      basic: true,
      className: "close-button",
      onClick: onClose
    }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      as: "a",
      basic: true,
      "data-qa": "learn-more-link",
      href: productHomepageLink,
      target: "_blank"
    }, "Learn more"), /*#__PURE__*/_react["default"].createElement(ActionButton, {
      productStatus: productStatus,
      targetProduct: targetProduct,
      onActionButtonClick: onActionButtonClick,
      isLoading: isLoading,
      isAccessRequested: isAccessRequested
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(_Message["default"], {
    error: true,
    content: "Something went wrong",
    "data-qa": "error"
  });
};

var ActionButton = function ActionButton(_ref2) {
  var productStatus = _ref2.productStatus,
      targetProduct = _ref2.targetProduct,
      onActionButtonClick = _ref2.onActionButtonClick,
      isLoading = _ref2.isLoading,
      isAccessRequested = _ref2.isAccessRequested;
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    primary: true,
    "data-qa": "activation-button-".concat(targetProduct),
    loading: isLoading,
    disabled: isLoading || isAccessRequested,
    onClick: onActionButtonClick
  }, getTitleForActionButton(productStatus, isAccessRequested));
};

function getTitleForActionButton(status, isAccessRequested) {
  if (isAccessRequested) {
    return 'Access requested';
  }

  switch (status) {
    case _productsStatus.PRODUCT_STATUS.CAN_ACTIVATE:
      return 'Start free trial';

    case _productsStatus.PRODUCT_STATUS.ACCESS_NEEDED:
      return 'Request access';

    default:
      return 'Something went wrong';
  }
}

function getCookie(cookieName) {
  var name = cookieName + '=';
  var cookiesArray = document.cookie.split(';');

  for (var i = 0; i < cookiesArray.length; i++) {
    var cookie = cookiesArray[i];

    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }

    if (cookie.indexOf(name) === 0) {
      var rawValue = cookie.substring(name.length, cookie.length); // URL-encoding is common but not required for cookies. Decode if
      // necessary, since url-parse will correctly encode the result.

      return decodeURIComponent(rawValue);
    }
  }

  return '';
}

function goToProduct(swicusOrgId, environment, productName) {
  var product = _apps["default"].find(function (app) {
    return app.id === productName;
  });

  var parsedUrl = (0, _urlParse["default"])(product.url.login[environment], true);
  parsedUrl.query = {
    utm_source: productName,
    utm_medium: 'app_switcher',
    tracking_code: getCookie('SWI_Referral'),
    ref: getCookie('SWI_RefUrl')
  };
  if (swicusOrgId) parsedUrl.query.swicus_org_id = swicusOrgId;
  window.open(parsedUrl.toString());
}